export const CUSTOM_PAGE_NAME_CHARACTER_LIMIT = 100;
export const CUSTOM_PAGE_DESC_CHARACTER_LIMIT = 256;
export const NUMBER_OF_PAGES_LIMIT = 100;
export const MODAL_WIDTH = 'medium';
export const HTTP_SERVER_ERROR = 500;

export const TRACK_EVENT_TYPE = 'track';
export const ALREADY_EXISTED_CUSTOM_PAGE_MESSAGE =
	'A custom page with this name already exists on your site. Try again with a different name.';
export const HARD_LIMIT_CUSTOM_PAGES_MESSAGE = `Pages limit of ${NUMBER_OF_PAGES_LIMIT} is exceeded`;

